"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultiplePropertyTransactionUserFields$ = exports.MultiplePropertyTransactionUserFields$outboundSchema = exports.MultiplePropertyTransactionUserFields$inboundSchema = exports.MultiplePropertyTransactionUserFields = void 0;
const z = __importStar(require("zod"));
exports.MultiplePropertyTransactionUserFields = {
    StreetGroupPropertyId: "street_group_property_id",
    Address: "address",
    TransactionId: "transaction_id",
    TransactionDate: "transaction_date",
    Price: "price",
    Location: "location",
    PropertyType: "property_type",
    IsNewBuild: "is_new_build",
    PricePerSquareMetre: "price_per_square_metre",
    InternalAreaSquareMetres: "internal_area_square_metres",
    NumberOfBedrooms: "number_of_bedrooms",
    NumberOfBathrooms: "number_of_bathrooms",
    Images: "images",
    StreetView: "street_view",
    Tenure: "tenure",
    DistanceInMetres: "distance_in_metres",
};
/** @internal */
exports.MultiplePropertyTransactionUserFields$inboundSchema = z.nativeEnum(exports.MultiplePropertyTransactionUserFields);
/** @internal */
exports.MultiplePropertyTransactionUserFields$outboundSchema = exports.MultiplePropertyTransactionUserFields$inboundSchema;
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var MultiplePropertyTransactionUserFields$;
(function (MultiplePropertyTransactionUserFields$) {
    /** @deprecated use `MultiplePropertyTransactionUserFields$inboundSchema` instead. */
    MultiplePropertyTransactionUserFields$.inboundSchema = exports.MultiplePropertyTransactionUserFields$inboundSchema;
    /** @deprecated use `MultiplePropertyTransactionUserFields$outboundSchema` instead. */
    MultiplePropertyTransactionUserFields$.outboundSchema = exports.MultiplePropertyTransactionUserFields$outboundSchema;
})(MultiplePropertyTransactionUserFields$ || (exports.MultiplePropertyTransactionUserFields$ = MultiplePropertyTransactionUserFields$ = {}));
//# sourceMappingURL=multiplepropertytransactionuserfields.js.map